import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5cc4c2c9")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.updateExists)
    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
        _createVNode("a", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refreshApp())),
          class: "sw-update-bg"
        }),
        _createVNode("div", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshApp())),
          class: "sw-update"
        }, " An update is available, click anywhere to continue. ")
      ], 64))
    : _createCommentVNode("", true)
})